import { render, staticRenderFns } from "./DocumentField.vue?vue&type=template&id=2f506814"
import script from "./DocumentField.vue?vue&type=script&lang=js"
export * from "./DocumentField.vue?vue&type=script&lang=js"
import style0 from "./DocumentField.vue?vue&type=style&index=0&id=2f506814&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports